import { combineReducers } from "redux";
import resourceReducer from "./resourceReducer";
import resourcePageReducer from "./resourcePageReducer";
import yearOfActionReducer from "./yearOfActionReducer";
import eventReducer from "./eventReducer";
import conferenceReducer from "./conferenceReducer";
import yearOfActionResourceReducer from "./yearOfActionResourceReducer";
import tagReducer from "./tagReducer";
import homeReducer from "./homeReducer";
import newsReducer from "./newsReducer";
import whatWeDoReducer from "./whatWeDoReducer";
import menuReduer from "./menuReduer";

export const AppReducer = combineReducers({
  resource: resourceReducer,
  yearOfAction: yearOfActionReducer,
  event: eventReducer,
  conference: conferenceReducer,
  yearOfActionResource: yearOfActionResourceReducer,
  tag: tagReducer,
  home: homeReducer,
  news: newsReducer,
  whatWeDo: whatWeDoReducer,
  resourcePage: resourcePageReducer,
  menu: menuReduer,
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js